var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDogHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8.0104399mm",
    height: "7.150075mm",
    viewBox: "0 0 8.0104399 7.150075",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-68.791661,-118.26875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dog_Head_OCC",
    onmouseover: "displayName('OCC - Ozark Correctional Center')",
    onmouseout: "displayName('')",
    onclick: "setCounty(this)",
    transform: "matrix(0.26458333,0,0,0.26458333,-33.830244,-13.68037)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Head_5_",
    fill: "#ffffff",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 395.533,502.079 c 0,0 7.929,-6.487 14.337,0 0.641,-0.44 3.563,-2.483 5.486,-0.562 0.601,0.602 2.282,2.522 2.282,2.522 v 5.527 c 0,0 -4.165,5.045 -4.125,7.487 -0.359,-1.28 -1.002,-4.169 -1.923,-4.968 -0.16,0.483 -0.881,1.845 -0.641,2.445 0.04,0.521 -0.36,1.881 -1.201,2.963 -0.28,0.401 -0.562,3.725 -0.562,3.725 0,0 -0.681,2.363 -3.203,2.243 -0.2,0.28 -4.045,3.809 -6.368,0.04 -0.521,-0.244 -3.563,-0.16 -3.845,-3.164 -0.039,-1.241 -0.239,-6.367 -0.239,-6.367 0,0 -2.082,-1.202 -1.922,-4.966 -0.041,2.923 0.069,9.011 0.069,9.011 0,0 -2.032,-0.28 -2.313,-1.481 -0.281,-1.201 -0.961,-3.004 -1.962,-3.846 -0.521,-0.561 -1.724,-5.927 -0.481,-7.85 1.241,-1.922 3.524,-3.684 3.524,-3.684 0,0 2.046,-1.357 3.087,0.925 z",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g873",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    transform: "matrix(0.43324901,0,0,0.76128083,232.55998,122.76287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 410.711,503.641 c 0,0 0.036,0.144 0.102,0.392 0.066,0.248 0.153,0.604 0.245,1.035 0.097,0.432 0.207,0.934 0.327,1.473 0.105,0.542 0.191,1.125 0.292,1.706 0.086,0.583 0.218,1.163 0.261,1.717 0.045,0.556 0.085,1.074 0.119,1.52 0.068,0.894 0.115,1.488 0.115,1.488 l -1,-0.037 c 0,0 0.018,-0.575 0.041,-1.439 0.013,-0.436 0.027,-0.941 0.043,-1.484 0.016,-0.545 -0.053,-1.125 -0.076,-1.708 -0.038,-0.583 -0.062,-1.168 -0.107,-1.714 -0.063,-0.545 -0.118,-1.055 -0.167,-1.49 -0.045,-0.438 -0.095,-0.802 -0.136,-1.055 -0.038,-0.259 -0.059,-0.404 -0.059,-0.404 z",
    id: "path873",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g874",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    transform: "matrix(0.49148996,0,0,0.78669034,200.05648,108.9396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 395.133,503.16 c 0,0 -0.096,0.039 -0.23,0.146 -0.075,0.042 -0.143,0.127 -0.225,0.213 -0.086,0.083 -0.172,0.186 -0.237,0.318 -0.068,0.13 -0.171,0.251 -0.226,0.41 -0.053,0.157 -0.108,0.324 -0.168,0.496 -0.072,0.163 -0.078,0.358 -0.109,0.547 -0.026,0.188 -0.055,0.378 -0.081,0.568 -0.013,0.389 0.007,0.779 0.008,1.141 -0.015,0.358 0.082,0.703 0.107,0.99 0.081,0.576 0.137,0.961 0.137,0.961 l -0.993,0.112 c 0,0 0.006,-0.412 0.015,-1.032 0.021,-0.31 -0.021,-0.662 0.051,-1.052 0.06,-0.386 0.104,-0.795 0.183,-1.196 0.061,-0.199 0.122,-0.397 0.182,-0.594 0.065,-0.191 0.102,-0.388 0.208,-0.558 0.091,-0.172 0.177,-0.338 0.261,-0.495 0.082,-0.154 0.213,-0.273 0.305,-0.396 0.091,-0.125 0.196,-0.218 0.3,-0.291 0.1,-0.075 0.178,-0.148 0.264,-0.183 0.15,-0.082 0.248,-0.105 0.248,-0.105 z",
    id: "path874",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Nose_5_",
    d: "m 400.819,519.662 -1.684,-1.802 c 0,0 -0.961,-0.96 0,-2.322 0.962,-0.802 3.124,-2.122 4.926,0 0.563,0.439 1.283,1.241 0.281,2.521 -0.842,0.642 -1.521,1.603 -1.521,1.603 0,0 -1.361,0.687 -2.002,0 z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ffffff",
    cx: 401.12,
    cy: 517.83899,
    rx: 1.421,
    ry: 0.69999999,
    id: "ellipse874",
    style: {
      display: "none",
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 406.23885,504.67935 c 0,0 2.403,0.32 3.164,1.441",
    id: "path875",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m 398.46429,504.55711 c 0,0 -2.403,0.318 -3.164,1.44",
    id: "path876",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.25006,
    cy: 614.82397,
    rx: 1.982,
    ry: 1.302,
    id: "ellipse876",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    transform: "rotate(-20)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 557.33899,
    cy: 339.7471,
    rx: 1.9809999,
    ry: 1.301,
    id: "ellipse877",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    transform: "rotate(20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g877",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    transform: "matrix(1.0904267,0,0,0.43903324,-36.285854,293.65099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 401.834,523.745 -2.136,-0.5 2.136,-0.5 c 0.276,-0.064 0.553,0.105 0.617,0.383 0.063,0.277 -0.107,0.553 -0.383,0.617 -0.079,0.019 -0.16,0.017 -0.234,0 z",
    id: "path877",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.40475,
    cy: 523.27692,
    rx: 2.8213112,
    ry: 0.19346738,
    id: "ellipse878",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.639539,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g878",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    transform: "matrix(1.1347591,0,0,0.36986238,-54.530712,329.81163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 405.565,523.245 -1.686,0.5 c -0.276,0.082 -0.565,-0.075 -0.647,-0.353 -0.082,-0.276 0.075,-0.565 0.352,-0.647 0.102,-0.03 0.203,-0.028 0.297,0 z",
    id: "path878",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogHead);
export default __webpack_public_path__ + "static/media/dog_head.b1aacdead503131966bfdaff3e4ba58c.svg";
export { ForwardRef as ReactComponent };